import { styled } from '@clickcease/cc-client-components-lib'

export const PlanFeaturesButtonsStyled = styled('div', {
  color: '$black',
  display: 'flex',
  fontWeight: '$sb',
  fontSize: '$h3',
  textAlign: 'center',
  justifyContent: 'space-between',
  margin: '60px 0px 12px 0px',
})

export const PlanFeaturesButtonsSection = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
  width: '242px',

  '&:nth-child(3)': {
    width: '230px',
  },
})

export const PlanFeaturesButtonsSeparator = styled('div', {
  width: '1px',
  height: '100px',
  background: '#DEE3F0',
  margin: '0px 0px',
})

export const PlanFeaturesButtonsSectionText = styled('div', {})
export const PlanFeatureText = styled('div', {
  fontWeight: '$b',
  fontSize: '40px',
  marginTop: '14px',
})

export const PlanFeaturesButtonsSectionWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
})
